import { useState } from 'react';
import { DownloadIcon, Loader2Icon } from 'lucide-react';
import { downloadCertificaat } from '../../pages/ELearnings.js';

/** Downloadknop voor het certificaat; alleen tonen bij status `geslaagd`. */
export function CertificaatKnop({ courseId }: { courseId: string }): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  async function handleClick(): Promise<void> {
    setBusy(true);
    setFailed(false);
    try {
      await downloadCertificaat(courseId);
    } catch {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mt-4">
      <button
        type="button"
        onClick={() => void handleClick()}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-xl bg-brand-600 px-5 py-2.5 text-[14px] font-semibold text-white transition-colors hover:bg-brand-700 disabled:opacity-50"
      >
        {busy ? <Loader2Icon size={16} className="animate-spin" /> : <DownloadIcon size={16} />}
        Certificaat downloaden
      </button>
      {failed && (
        <p className="mt-2 text-[12px] text-red-700">Downloaden mislukt. Probeer het opnieuw.</p>
      )}
    </div>
  );
}
